var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    staticClass: "card",
    attrs: {
      "flat": "",
      "rounded": ""
    }
  }, [_c('v-card-title', {
    staticClass: "card-title transparent text-h4 font-weight-bold secondary--text"
  }, [_c('router-link', {
    staticClass: "text-h4 font-weight-bold secondary--text text-decoration-none",
    attrs: {
      "to": {
        name: 'new-material'
      }
    }
  }, [_vm._v("LATEST ARRIVALS ")])], 1), _c('v-card-text', {
    staticClass: "d-flex align-center justify-center",
    staticStyle: {
      "height": "100%"
    }
  }, [_vm.isLoading || _vm.newMaterialLists.length < 1 ? _c('v-card', {
    attrs: {
      "color": "transparent",
      "flat": ""
    }
  }, [_c('v-card-text', {
    staticClass: "d-flex flex-column align-center justify-center"
  }, [_vm.isLoading ? _c('v-progress-circular', {
    staticClass: "mt-4",
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  }) : _vm._e(), _c('p', {
    staticClass: "text-h6 primary--text"
  }, [_vm._v("Getting latest arrivals...")])], 1), _c('v-card-actions')], 1) : _c('v-row', {
    staticClass: "card-text d-flex align-center justify-center flex-wrap",
    attrs: {
      "width": "100%"
    }
  }, _vm._l(_vm.newMaterialLists, function (list) {
    return _c('v-col', {
      key: list.category,
      staticClass: "carousel-container d-flex flex-column align-center justify-center mt-4 px-0 px-sm-2",
      class: ("ma-" + (_vm.$vuetify.breakpoint.mdAndDown ? '0' : 'auto')),
      attrs: {
        "cols": "12",
        "sm": "6",
        "lg": "4",
        "align-self": "stretch",
        "color": "transparent"
      }
    }, [_c('v-sheet', {
      staticClass: "d-flex align-center justify-center",
      attrs: {
        "color": "transparent",
        "height": "300px",
        "width": "100%"
      }
    }, [_c('carousel', {
      attrs: {
        "itemList": list
      },
      on: {
        "active-item": _vm.setActiveItem
      }
    })], 1), _c('v-sheet', {
      attrs: {
        "color": "transparent",
        "max-width": _vm.$vuetify.breakpoint.xs ? 240 : 300,
        "width": "100%"
      }
    }, [_c('v-btn', {
      staticClass: "action-btn",
      attrs: {
        "block": "",
        "color": "primary",
        "large": "",
        "rounded": "",
        "to": ("/new-material/" + (list.slug))
      }
    }, [_c('v-icon', {
      staticClass: "mr-2",
      attrs: {
        "color": "secondary"
      }
    }, [_vm._v("mdi-format-list-bulleted")]), _c('span', {
      attrs: {
        "clss": "secondary--text font-weight-bold"
      }
    }, [_vm._v(_vm._s(list.category))])], 1)], 1)], 1);
  }), 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }